import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useHistory } from "react-router";
import Sidebar from "../../../partials/aside/Sidebar";
import TitleBar from "../../../partials/content/TitleBar";
import helperSpinner from "../../../../helpers/spinner";
import helpersNumbers from "../../../../helpers/numbers";
import helperTime from "../../../../helpers/time";
import httpService from "../../../../services/httpServices/httpServices";
import typeTransactionManually from "./typeTransactionManually";

export default function AddTransactionManually() {
  const [amount, setAmount] = useState(0);
  const [userPublisherSelected, setUserPublisherSelected] = useState();
  const [allUserPublisher, setAllUserPublisher] = useState([]);
  const history = useHistory();
  useEffect(() => {
    getAllUserPublisher();
  }, []);

  const getHeaderRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const getAllUserPublisher = async () => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    let allUserPublisher = await sendRequestGetAllUserPublisher();
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);

    if (!allUserPublisher) {
      return;
    }
    setAllUserPublisher(allUserPublisher);
  };

  const sendRequestGetAllUserPublisher = async () => {
    const headersRequest = getHeaderRequest();
    let allUserPublisher;
    try {
      allUserPublisher = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/manage/publisher/user/all-publisher/list",
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return allUserPublisher.data.data;
  };

  const inputAmountChangeHandler = (e) => {
    let number = e.target.value;
    number = helpersNumbers.toEnglishNumber(number.replaceAll(",", ""));
    if (number == "") {
      number = 0;
    }
    setAmount(parseInt(number));
  };

  const inputAmountBeforeInputHandler = (e) => {
    const regexLetter = new RegExp("^[0-9\b]+$");
    if (!regexLetter.test(e.data)) {
      e.preventDefault();
      return;
    }
  };

  const generateAllUserPublisherInOptionInSelectTag = () => {
    return allUserPublisher.map((userPublisher) => {
      return (
        <option value={userPublisher.user_id}>
          {`${userPublisher.firstname} ${userPublisher.lastname} `}
        </option>
      );
    });
  };

  const changeSelectAllUserPublisher = (e) => {
    const userIDSelected = parseInt(e.target.value);
    if (!userIDSelected) {
      setUserPublisherSelected();
      return;
    }
    allUserPublisher.forEach((item) => {
      if (item.user_id == userIDSelected) {
        setUserPublisherSelected(item);
        return;
      }
    });
  };

  const sendRequestAddTransactionManually = async (formData) => {
    const headersRequest = getHeaderRequest();
    try {
      await httpService.postRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/manage/publisher/finance/transaction-manually",
        formData,
        headersRequest
      );
      return true;
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }
  };

  const sendForm = async () => {
    const formData = getFormData();
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    let resultAddTransactionManually = await sendRequestAddTransactionManually(
      formData
    );
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);

    if (!resultAddTransactionManually) {
      return;
    }

    history.push("/finance/manage/transaction-manually/all");
  };

  const getFormData = () => {
    return {
      publisher_user_ID: parseInt(
        document.querySelector("#all-user-publisher").value
      ),
      amount: amount,
      operate: parseInt(document.querySelector("#type-operate").value),
      type: parseInt(document.querySelector("#type-unit").value),
      reason: document.querySelector("#reason").value,
    };
  };

  return (
    <>
      <Sidebar />

      <div className="content-wrapper">
        <TitleBar title="تراکنش های دستی جدید" />

        <section className="content pt-5">
          <div className="card">
            <div className="card-body">
              <div className="text-left">
                <Link
                  className="btn btn-primary"
                  to="/finance/manage/transaction-manually/all"
                >
                  <span>بازگشت</span>
                  <span className="pr-2">
                    <i className="fas fa-arrow-left"></i>
                  </span>
                </Link>
              </div>
              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  sendForm();
                }}
              >
                <div className="form-group">
                  <label>مبلغ (تومان)</label>
                  <input
                    tabindex="1"
                    type="text"
                    id="price"
                    className="form-control number-finance"
                    value={helpersNumbers.toPersianNum(
                      helpersNumbers.toFormatFinanceNumber(amount)
                    )}
                    onChange={inputAmountChangeHandler}
                    onBeforeInput={inputAmountBeforeInputHandler}
                    dir="ltr"
                    required
                  />
                </div>
                <div>
                  <label>کاربر نمایش دهنده</label>
                  <select
                    className="form-control"
                    id="all-user-publisher"
                    onChange={changeSelectAllUserPublisher}
                  >
                    {allUserPublisher.length > 0 && (
                      <>
                        <option value="0">انتخاب کنید</option>
                        {generateAllUserPublisherInOptionInSelectTag()}
                      </>
                    )}
                  </select>

                  {userPublisherSelected && (
                    <>
                      <ul className="py-2 d-flex" style={{ listStyle: "none" }}>
                        <li className="px-2"> شماره کاربر</li>
                        <li className="px-2"> : </li>
                        <li className="px-2">
                          {" "}
                          {userPublisherSelected.user_id}
                        </li>
                        <li className="px-2"> نام کاربر</li>
                        <li className="px-2"> : </li>
                        <li className="px-2">
                          {userPublisherSelected.firstname}{" "}
                          {userPublisherSelected.lastname}{" "}
                        </li>
                        <li className="px-2"> موجودی کاربر</li>
                        <li className="px-2">:</li>
                        <li className="px-2 letter-spacing-finance-number">
                          {helpersNumbers.toPersianNum(
                            helpersNumbers.toFormatFinanceNumber(
                              userPublisherSelected.publisher_wallet
                            )
                          )}
                        </li>
                        <li className="px-2"> تومان</li>
                        <li className="px-2">Hicoin کاربر</li>
                        <li className="px-2 ">:</li>
                        <li className="px-2 letter-spacing-finance-number">
                          {helpersNumbers.toPersianNum(
                            helpersNumbers.toFormatFinanceNumber(
                              userPublisherSelected.publisher_score
                            )
                          )}{" "}
                        </li>
                        <li className="px-2"> تومان</li>
                      </ul>
                      <hr />
                    </>
                  )}
                </div>
                <div className="form-group">
                  <label>نوع تراکنش</label>
                  <select id="type-operate" className="form-control">
                    <option
                      value={typeTransactionManually.typeOperate.INCREASE}
                    >
                      {
                        typeTransactionManually.getTypeOperateString()[
                          typeTransactionManually.typeOperate.INCREASE
                        ]
                      }
                    </option>
                    <option
                      value={typeTransactionManually.typeOperate.DECREASE}
                    >
                      {
                        typeTransactionManually.getTypeOperateString()[
                          typeTransactionManually.typeOperate.DECREASE
                        ]
                      }
                    </option>
                  </select>
                </div>
                <div className="form-group">
                  <label>واحد تراکنش </label>
                  <select id="type-unit" className="form-control">
                    <option value={typeTransactionManually.typeValue.WALLET}>
                      {
                        typeTransactionManually.getTypeValueString()[
                          typeTransactionManually.typeValue.WALLET
                        ]
                      }
                    </option>
                    <option value={typeTransactionManually.typeValue.SCORE}>
                      {
                        typeTransactionManually.getTypeValueString()[
                          typeTransactionManually.typeValue.SCORE
                        ]
                      }
                    </option>
                  </select>
                </div>
                <div className="form-group">
                  <label>دلیل خود را از این تراکنش بنویسید</label>
                  <div>
                    <textarea
                      id="reason"
                      className="form-control"
                      rows="5"
                      required
                    ></textarea>
                  </div>
                </div>
                <div className="form-group">
                  <button className="btn btn-success">ارسال</button>
                </div>
              </form>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
